export interface ViaCepAddress {
  cep: string;
  logradouro: string;
  bairro: string;
  localidade: string;
  uf: string;
}

export function normalizeCep(raw: string): string {
  return raw.replace(/\D/g, "").slice(0, 8);
}

export function formatCep(raw: string): string {
  const digits = normalizeCep(raw);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

export function formatAddressFromCep(address: ViaCepAddress): string {
  const parts = [address.logradouro, address.bairro, `${address.localidade} - ${address.uf}`];
  return parts.filter((part) => part && part.trim().length > 0).join(", ");
}

export async function lookupCep(rawCep: string): Promise<ViaCepAddress | null> {
  const cep = normalizeCep(rawCep);
  if (cep.length !== 8) return null;

  const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
  if (!response.ok) throw new Error("CEP lookup failed");

  const data = (await response.json()) as Partial<ViaCepAddress> & { erro?: boolean };
  if (data.erro) return null;
  if (!data.logradouro && !data.localidade) return null;

  return {
    cep: data.cep ?? cep,
    logradouro: data.logradouro ?? "",
    bairro: data.bairro ?? "",
    localidade: data.localidade ?? "",
    uf: data.uf ?? "",
  };
}
